<template>
    <div class="settings-manager">
        <SettingsCard
            v-for="(setting, index) in inSettings"
            :key="index"
            :type="type"
            :setting="setting"
            @edit="openSetting(setting.name)"
            @reload="reload"
        />

        <SettingsModal
            v-if="modalOpen"
            :setting="activeSetting"
            :pre-value="apolloData[modal.open]"
            @close="closeSetting"
            @save="saveSetting"
        />
    </div>
</template>

<script>
import SettingsCard from '@/components/SettingsCard'
import SettingsModal from '@/components/SettingsModal'

export default {
    name: 'SettingsManager',
    components: {
        SettingsCard,
        SettingsModal,
    },
    props: {
        settings: {
            type: Array,
            required: true,
        },
        apolloData: {
            type: Object,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            modal: {
                open: false,
            },
            inSettings: [...this.settings],
        }
    },
    computed: {
        activeSetting() {
            return this.inSettings.find((x) => x.name === this.modal.open)
        },
        modalOpen() {
            return this.modal.open !== false
        },
    },
    mounted() {
        this.inSettings.forEach((setting) => {
            setting.value = this.apolloData[setting.name]
        })
    },
    methods: {
        openSetting(name) {
            this.modal.open = name
        },
        closeSetting() {
            this.modal.open = false
        },
        saveSetting(setting) {
            if (setting) {
                this.modal.open = false
                this.$emit('save', setting)
            }
        },
        reload() {
            this.$emit('reload')
        },
    },
}
</script>

<style scoped lang="sass"></style>
